import React from 'react';
import './index.scss';

const CompanyHightlightSlot = ({
  showCompanyHighLight,
  sellerSelfOperated = false,
}) => {
  if (!showCompanyHighLight || sellerSelfOperated) return null;

  return (
    <div
      className="alisite"
      data-module="alisite"
      data-scene="companyKeyCapacity"
    >
      {/* <div className="loading">
        <i className="loading-icon next-icon next-icon-loading next-icon-large" />
      </div> */}
    </div>
  );
};

export default CompanyHightlightSlot;
